var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9229 1.34763C1.56211 1.34771 1.27059 1.63923 1.27059 1.99994C1.27051 2.36073 1.56212 2.65234 1.92292 2.65226C9.48334 2.65246 6.33602 2.65239 14.3183 2.65248C14.4983 2.65248 14.6616 2.57958 14.7796 2.46148C14.8977 2.34339 14.9706 2.1801 14.9706 2.00017C14.9707 1.63937 14.6791 1.34776 14.3183 1.34784C6.70301 1.34765 9.9572 1.34784 1.9229 1.34763Z",
    fill: "#1B203D",
    stroke: "#1B203D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.1ecacac637fa8eaf221ce6eecb1efd58.svg";
export { ForwardRef as ReactComponent };